import { render } from "./SvgComponent.vue?vue&type=template&id=1c6db0d8"
import script from "./SvgComponent.vue?vue&type=script&lang=js"
export * from "./SvgComponent.vue?vue&type=script&lang=js"

import "./SvgComponent.vue?vue&type=style&index=0&id=1c6db0d8&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__